import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, tap, catchError } from 'rxjs';
import { environment } from '../../environments/environment';
import { throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private tokenKey = 'auth_token';
  private loggedIn$ = new BehaviorSubject<boolean>(this.isAuthenticated());

  constructor() {
    console.log('🔧 AuthService inicializado');
    console.log('🌐 API URL:', environment.apiUrl);
    console.log('🎫 Token actual:', this.getToken());
  }

  // ========= AUTENTICACIÓN =========

  login(email: string, password: string) {
    console.log('📡 Enviando petición de login a:', `${environment.apiUrl}/auth/login`);
    console.log('📝 Datos enviados:', { email, password: '***' });

    return this.http.post<{ token: string }>(`${environment.apiUrl}/auth/login`, { email, password })
      .pipe(
        tap(response => {
          console.log('✅ Respuesta del servidor:', response);
          localStorage.setItem(this.tokenKey, response.token);
          this.loggedIn$.next(true);
          console.log('💾 Token guardado en localStorage');
        }),
        catchError(error => {
          console.error('❌ Error en petición HTTP:', error);
          console.error('📄 Status:', error.status);
          console.error('📄 Message:', error.message);
          console.error('📄 Error completo:', error);
          return throwError(() => error);
        })
      );
  }

  logout() {
    localStorage.removeItem(this.tokenKey);
    this.loggedIn$.next(false);
    this.router.navigate(['/login']);
  }

  // Observable para componentes que quieran reaccionar a cambios
  isLoggedIn() {
    return this.loggedIn$.asObservable();
  }

  // ========= TOKEN / USUARIO =========

  getToken() {
    return localStorage.getItem(this.tokenKey);
  }

  /**
   * Devuelve true si hay token **y** no está expirado (si es JWT).
   * Este es el método que deben usar los guards.
   */
  isAuthenticated(): boolean {
    const token = this.getToken();
    if (!token) return false;

    // Si parece JWT, validamos 'exp'; si no, basta con que exista
    const parts = token.split('.');
    if (parts.length !== 3) return true;

    try {
      const payload = JSON.parse(atob(parts[1] || ''));
      const now = Math.floor(Date.now() / 1000);
      // margen de 60s por posible desajuste de reloj
      if (payload?.exp && payload.exp <= (now + 60)) {
        return false;
      }
      return true;
    } catch (err) {
      console.warn('⚠️ No se pudo decodificar el payload del token, se asume válido:', err);
      return true;
    }
  }

  /**
   * Conservamos tu método, pero OJO: solo verifica existencia del token.
   * Para guards usa isAuthenticated().
   */
  hasToken(): boolean {
    return !!localStorage.getItem(this.tokenKey);
  }

  getUsuarioAutenticado() {
    const token = this.getToken();
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      console.log('🎫 Payload completo del JWT:', payload);
      return {
        id: payload.sub,
        rol: payload.rol,
        exp: payload.exp,
        iat: payload.iat,
        ...payload
      };
    } catch (error) {
      console.error('Error decodificando token:', error);
      return null;
    }
  }
}
